export default {
  props: {
    baseUrl: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: false
    },
    permisoEditar: {
      type: String,
      required: false
    },
    permisoEliminar: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    camposIgnorados: {
      type: Array,
      default: () => [],
    },
    selectActions: {
      type: Array,
      default() {
        return [
          {name: 'Agregar', icon: 'add', permissoPrefix: 'Crear'},
          {name: 'Editar', icon: 'edit', permissoPrefix: 'Editar'},
        ];
      },
    },
  },
  computed: {
    camposIgnoradosComputed() {
      return this.camposIgnorados;
    },
  },
}
